<script setup lang="ts">
    import { useCaseSettingsViewModel } from '@/views/case-settings/composables/useCaseSettingsViewModel';
    import measureIcon from '@/assets/icons/measure.svg';
    import { CASE_SETTINGS_TARGETS } from '@/domain/analytics/analyticsTargets';

    const vm = useCaseSettingsViewModel();
</script>

<template>
    <v-row justify="start" no-gutters>
        <v-col>
            <div class="section-title-div">
                <img
                    :src="measureIcon"
                    alt="Surgical Guide Settings Icon"
                    width="24px"
                    class="mt-1"
                />
                <app-form-section-title class="mb-8" data-testid="surgical-guide-settings-section">
                    Surgical Guide Settings
                </app-form-section-title>
            </div>
        </v-col>
        <template v-if="vm.showOrderedBanner">
            <v-col class="pt-2 ml-12">
                <span
                    >CR Number <b>{{ vm.surgicalGuide.crNumber }}</b></span
                >
            </v-col>
            <v-col class="text-end" cols="auto">
                <v-alert class="rounded-pill mt-3 ordered text-end" :border="false">
                    Guide Successfully Ordered
                </v-alert>
            </v-col>
        </template>
    </v-row>

    <template v-if="!vm.showOrderedBanner">
        <app-form-subtitle class="mb-6">
            Once the guide has been ordered these cannot be changed
        </app-form-subtitle>

        <v-container class="px-10 pt-0">
            <app-form-group
                label="CR Number"
                optional
                input-id="cr-number-input"
                :data-analytics-id="CASE_SETTINGS_TARGETS.crNumberInput"
            >
                <app-text-input
                    v-model="vm.surgicalGuide.crNumber"
                    data-testid="cr-number-input"
                    type="text"
                    input-id="cr-number-input"
                    :disabled="!vm.canEditCRNumber || vm.isCaseReadonly"
                    placeholder="Enter CR number"
                    maxlength="100"
                    inputmode="numeric"
                    :error-messages="
                        vm.checkSurgicalGuideFieldError('crNumber')
                            ? 'CR number must contain only numbers or must be left blank'
                            : ''
                    "
                />
            </app-form-group>

            <app-form-group label="Surgical Approach" optional data-testid="surgical-approach">
                <app-toggle
                    v-model="vm.surgicalGuide.surgicalApproachId"
                    :options="vm.surgicalApproachOptions"
                    :disabled="vm.isCaseReadonly"
                />
            </app-form-group>
        </v-container>
    </template>
</template>

<style lang="scss">
    .ordered {
        background-color: rgb(var(--v-theme-green), 0.3);
        color: rgb(var(--v-theme-green-hover));
        padding: 3px 10px;
        width: fit-content;
        font-size: 12px;
    }

    .section-title-div {
        display: flex;
        align-items: start;
        gap: 16px;
    }
</style>
